import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown, faAngleUp, faClock, faInfo, faChevronLeft, faChevronUp, faChevronDown, faChevronRight, faEdit, faBars } from '@fortawesome/free-solid-svg-icons'
import ReactPaginate from 'react-paginate'
import { savePortfolioAsNewStrategy, showPersonalStrategy, showStrategyEditor, getBenchmarks } from '../../../actions/data'
import { loadPersonalStrategies, showAllStrategies, closeStrategyEditor, updateStategyDetails, saveNewStrategy } from '../../../actions/data'
import i18n from '../../../i18n.js'
import './StrategyList.css'
import StrategyRow from './StrategyRow'
import StrategyEditor from '../StrategyEditor/StrategyEditor'
import StrategySelect from './StrategySelect'
// import ImportantInfoModal from '../ImportantInfoModal/ImportantInfoModal.js'
import TickerSelection from '../TickerSelection/TickerSelection'
import { Spinner } from '../Components/Spinner'

library.add(faClock, faAngleDown, faAngleUp, faInfo, faChevronLeft, faChevronUp, faChevronDown, faChevronRight, faEdit, faBars)
export const KEY_METRICS = ['periodicity']

function getQueryParams(hashString) {
  // Remove the app name
  const params = hashString.slice(1)

  // Get the params into key/value array
  const queryParams = params.reduce(function (map, obj) {
    const pair = obj.split('=')
    map[pair[0]] = pair[1]
    return map
  }, {})

  return queryParams
}

class StrategyList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currPage: 0,
      numPerPage: 5,
      importantInfoOpen: false
    }

    this.paginate = this.paginate.bind(this)
    this.handleShowEditor = this.handleShowEditor.bind(this)
    this.handleShowImportantInfoModal = this.handleShowImportantInfoModal.bind(this)
  }

  componentDidMount() {
    this.props.loadPersonalStrategies()
  }

  paginate({ selected }) {
    this.setState(
      Object.assign({}, this.state, {
        currPage: selected
      })
    )
  }

  handleShowEditor() {
    this.setState({
      importantInfoOpen: false
    })
    this.props.showStrategyEditor(null)
  }

  handleShowImportantInfoModal() {
    this.setState({
      importantInfoOpen: true
    })
  }

  listenForUrlChanges() {
    const { history } = this.props
    // console.log('history', history)
    const unlisten = history.listen(() => {
      // Get the hash and split it by '&'
      const hash = history.location.hash.substring(1).split('&')

      // If there is only the app name then ignore
      if (hash.length === 1) {
        return
      }

      // Get the query params from the rest of the hash
      const queryParams = getQueryParams(hash)
      //console.log('queryParams', queryParams)

      // console.log('hash[0]', hash[0])

      switch (hash[0]) {
        // Check for DPD requests
        case 'dpd':
        case 'portfolio-analysis':
          // Check if the saveToMyPortfolios flag has been added
          if (queryParams['saveToMyPortfolios'] && this.state.portfolioToSave !== queryParams['saveToMyPortfolios']) {
            this.setState({
              portfolioToSave: queryParams['saveToMyPortfolios']
            })
            this.props.savePortfolioAsNewStrategy(queryParams['saveToMyPortfolios'], queryParams['portfolioName'] ? decodeURI(queryParams['portfolioName']) : undefined)
          }

          break

        // Check for personal strategies requests
        case 'myportfolios':
        case 'my-portfolio-hub':
          // Check if the myPortfolioId flag has been added
          if (queryParams['myportfolioid']) {
            // Load the Personal Strategy directly
            const myPortfolioId = queryParams['myportfolioid']
            // console.log('Loading MyPortfolio with id ' + myPortfolioId)
            this.props.showPersonalStrategy(myPortfolioId)
          } else if (queryParams['newstrategy']) {
            this.props.showStrategyEditor(null)
          }

          break

        default:
      }
    })

    return unlisten
  }
  
  render() {
    const { currPage, numPerPage, importantInfoOpen } = this.state
    const { closeStrategyEditor, updateStategyDetails, saveNewStrategy } = this.props
    const { strategyIdToShow, strategyEditorVisible, strategyToEdit, strategySaveInProgress, personalStrategies } = this.props.personalStrategies

    // Define the StrategyEditor component
    const strategyEditor = <StrategyEditor key={strategyToEdit ? strategyToEdit.id : 'new-strategy-editor'} showEditor={strategyEditorVisible} strategyToEdit={strategyToEdit} closeEditor={closeStrategyEditor} saveNewStrategy={saveNewStrategy} updateStategyDetails={updateStategyDetails} params={this.props.params} typeaheadUrl={`${process.env.REACT_APP_DPD_API_URL}/api/securityfund/typeahead/`} checkTickersUrl={`${process.env.REACT_APP_DPD_API_URL}/api/securityfund/ticker_names/`} benchmarks={this.props.data.benchmarks} />

    const strategies = this.props.personalStrategies.personalStrategies
    const min = currPage * numPerPage
    const max = min + numPerPage
    if (strategies && strategies.length > 0) {
      const strategiesToList = strategies.slice(min, max)
      const pageCount = Math.ceil(strategies.length / numPerPage)

      return (
        <div className='strategyBlendList'>
          <div className='row'>
            <div className='selectCopy col-sm-12'>{i18n.t('create-portfolio')}</div>
            <div className='selectBenchmark col-sm-12'>{i18n.t('default-benchmark-select')}</div>
          </div>
          <StrategySelect strategiesToList={strategies} />
          <TickerSelection />
          <div className='headers'>
            <div className='menu title'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{i18n.t('name')}</div>
            <div className='name title'></div>
            <div className='last-updated title'>{i18n.t('last-edited')}</div>
            <div className='statistics'>
              {
                // Render the headers and ? modal popouts
                KEY_METRICS.map(metric => {
                  return (
                    <div className={'stat-' + metric} key={'stat-' + metric} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <div className='stat-heading'>
                        <div className='title'>{i18n.t('num-holdings')}</div>
                        {/* <div className='more-info'>
                          <FontAwesomeIcon data-tip data-for={metric + '-desc'} icon='question-circle' size='sm' />
                        </div> */}
                      </div>
                      <ReactTooltip id={metric + '-desc'} type='light' className='tooltip' effect='float'>
                        {i18n.t(metric + '-desc')}
                      </ReactTooltip>
                    </div>
                  )
                })
              }
            </div>
          </div>

          {
            // Loop over the Personal Strategies and draw out the rows
            strategiesToList.map((strategy, index) => {
              // If the user has clicked a menu then only only Strategy should be shown
              if (strategyIdToShow === null || strategyIdToShow === undefined || strategy.id === strategyIdToShow) {
                return (
                  <StrategyRow
                    personalStrategy={strategy}
                    openMenu={strategyIdToShow == null ? false : true}
                    key={strategy.id}
                    striped={index % 2 !== 0} // Make every even row stripped
                    // If there is a save in progress for this strategy then let the row know
                    saveInProgress={strategySaveInProgress && strategySaveInProgress === strategy.id}
                  />
                )
              } else {
                return null
              }
            })
          }

          {/* Show the New Strategy button if there isn't a Strategy being viewed */}
          {!strategyIdToShow ? (
            <div className='last-row'>
              <div className='row-pagination'>
                {/* Show pagination */}
                <ReactPaginate previousLabel={<FontAwesomeIcon icon='chevron-left' size='xs' />} nextLabel={<FontAwesomeIcon icon='chevron-right' size='xs' />} pageCount={pageCount} marginPagesDisplayed={pageCount} pageRangeDisplayed={pageCount} onPageChange={this.paginate} containerClassName={'pagination'} pageClassName={'page-item'} pageLinkClassName={'page-item'} previousClassName={'page-item'} previousLinkClassName={'pageLink'} nextClassName={'page-item'} nextLinkClassName={'pageLink'} activeClassName={'active'} disabledClassName={'disabled'} />
              </div>
              <div className='new-strategy'>
                {/* Add the 'ADD' button without passing in a PersonalStrategy to load into it */}
                <button className='new-portfolio-button' onClick={this.handleShowEditor}>
                  {i18n.t('new-strategy')}
                </button>
              </div>
            </div>
          ) : null}
          {/* Add the StrategyEditor that will get opened when 'Add' is pressed
                        or an individual row is edited */}
          {strategyEditor}
        </div>
      )
    } else if (personalStrategies && personalStrategies.length === 0) {
      return (
        <div className='no-strategies'>
          <div className='no-strategies-label'>
            <h4>{i18n.t('no-strategies')}</h4>
          </div>
          <div className='new-strategy'>
            <button onClick={this.handleShowEditor}>{i18n.t('new-strategy')}</button>
          </div>

          {/* Modal for Important Information - only shown when a new strategy
              is clicked and none already exist */}
          {/* <ImportantInfoModal isOpen={importantInfoOpen} onClose={this.handleShowEditor} /> */}

          {/* Add the StrategyEditor that will get opened when 'Add' is pressed
                  or an individual row is edited */}
          {strategyEditor}
        </div>
      )
    }
    return <Spinner />
  }
}
function mapStateToProps(state) {
  return {
    data: state.fundData,
    params: state.params,
    personalStrategies: state.data
  }
}

export default connect(mapStateToProps, {
  loadPersonalStrategies,
  showAllStrategies,
  closeStrategyEditor,
  updateStategyDetails,
  saveNewStrategy,
  savePortfolioAsNewStrategy,
  showPersonalStrategy,
  showStrategyEditor,
  getBenchmarks
})(StrategyList)

//export default connect(mapStateToProps, mapDispatchToProps)(PortfolioList);
